import { OrderItemApi } from "../../../../../../../../../services/Api/Organization/types";

export const getOrderItemNetPriceAmount = (item: OrderItemApi) => {
	if (!item?.price_net_money && !item?.price_gross_money) return null;

	let amount = 0;
	if (!item.price_net_money && item?.price_gross_money) amount = item.price_gross_money.amount;
	else if (item?.price_net_money && !item.price_gross_money) amount = item.price_net_money.amount;
	else amount = item.price_net_money.amount / item.price_gross_money.amount;

	return amount;
};
